





































































































































































































































































import BaseComponent from '@/core/base.component';
import { Component, Vue } from 'vue-property-decorator';
import {
  CompanyDistrictDto,
  CompanyDistrictPromotionDto,
  CompanyDistrictPromotionListDto,
} from '@/dto';
import CompanyDistrictPromotionService from '@/services/company-district-promotion.service';
import { CONST_YN, Pagination, YN } from '@/common';
import CodeManagementService from '@/services/code-management.service';
import CompanyDistrictService from '@/services/company-district.service';
import toast from '../../../../resources/assets/js/services/toast.js';
import { APPROVAL_STATUS } from '@/services/shared';
import { VueEditor } from 'vue2-editor';
import { EditorConfig } from '../../../config';
import {
  ClearOutQueryParamMapper,
  ReverseQueryParamMapper,
  RouterQueryParamMapper,
} from '@/core';

@Component({
  name: 'CompanyDistrictPromotionList',
  components: {
    VueEditor,
  },
})
export default class PromotionList extends BaseComponent {
  private promotionSearchDto = new CompanyDistrictPromotionListDto();
  private promotionCreateDto = new CompanyDistrictPromotionDto();
  private promotionList: CompanyDistrictPromotionDto[] = [];
  private promotionTotalCount = null;
  private pagination = new Pagination();
  private dataLoading = false;
  private promitionTypeSelect = [];
  private companyDistrictSelect = [];
  private companyDistrictDto = new CompanyDistrictDto();
  private showYn: YN[] = [...CONST_YN];
  private companyDistrictIds: number[] = [];
  private editorToolbar = EditorConfig;

  findAll(isPagination?: boolean, isSearch?: boolean) {
    this.dataLoading = true;
    if (!isPagination) {
      this.pagination.page = 1;
    } else {
      if (isSearch) this.pagination.page = 1;
      RouterQueryParamMapper(this.promotionSearchDto, this.pagination);
    }
    CompanyDistrictPromotionService.findAll(
      this.promotionSearchDto,
      this.pagination,
    ).subscribe(res => {
      if (res) {
        this.dataLoading = false;
        this.promotionList = res.data.items;
        this.promotionTotalCount = res.data.totalCount;
      }
    });
  }

  search() {
    this.findAll(true, true);
  }

  paginateSearch() {
    this.findAll(true);
  }

  clearOut() {
    if (location.search) {
      ClearOutQueryParamMapper();
    } else {
      this.promotionSearchDto = new CompanyDistrictPromotionListDto();
      this.findAll();
    }
  }

  getCompanyDistrict() {
    const companyDistrictDto = new CompanyDistrictDto();
    CompanyDistrictService.findForSelectOption(companyDistrictDto).subscribe(
      res => {
        if (res) {
          this.companyDistrictSelect = res.data;
        }
      },
    );
  }

  addDistrict(districtNo) {
    if (this.companyDistrictIds.includes(parseInt(districtNo))) {
      const index = this.companyDistrictIds.indexOf(parseInt(districtNo));
      if (index > -1) {
        this.companyDistrictIds.splice(index, 1);
      }
    } else {
      this.companyDistrictIds.unshift(parseInt(districtNo));
    }
  }

  createPromotion() {
    this.promotionCreateDto.companyDistrictIds = this.companyDistrictIds;
    CompanyDistrictPromotionService.create(this.promotionCreateDto).subscribe(
      res => {
        if (res) {
          toast.success('추가완료');
          this.clearOut();
        }
      },
    );
  }

  created() {
    const query = ReverseQueryParamMapper(location.search);
    if (query) {
      this.promotionSearchDto = query;
      if (!isNaN(+query.limit) && !isNaN(+query.page)) {
        this.pagination.limit = +query.limit;
        this.pagination.page = +query.page;
      } else {
        this.pagination = new Pagination();
      }
      this.paginateSearch();
    } else {
      this.findAll();
    }
    this.getCommonCodes('promitionTypeSelect', 'B2B_EVENT_TYPE');
    this.getCompanyDistrict();
  }
}
